<template>
  <div class="uk-margin uk-grid-small uk-child-width-auto uk-grid">
    <label v-if="!disableAllOption">
      <input class="uk-radio" type="radio" :name="props.name" :checked="isChecked(null)" @change="handleChange($event, null)">
      <span v-html="l('All')"/>
    </label>
    <label v-for="option in options">
      <input class="uk-radio" type="radio" :name="props.name" :value="option" :checked="isChecked(option)" @change="handleChange($event, option)">
      <span v-html="option[optionLabelKey]"/>
    </label>
  </div>
</template>

<script setup>
import {onMounted, ref, isProxy, toRaw} from 'vue'

const emit = defineEmits(['update:modelValue', 'change'])

const props = defineProps({
  optionLabelKey: {type: String, required: true},
  optionChildrenKey: {type: String, required: true},
  modelValue: {
    type: null
  },
  name: {
    type: String,
    required: true
  },
  placeholder: {
    type: String,
  },
  options: {
    type: Array,
    required: true
  },
  disableAllOption: {
    type: Boolean
  }
})

const l = window.l

let selected = ref(null)

let isChecked = (option) => {
  const a = isProxy(selected.value) ? toRaw((selected.value)) : selected.value
  const b = isProxy(option) ? toRaw(option) : option
  return a === b
}

let handleChange = ($event, item) => {
  selected.value = item;
  emit('update:modelValue',selected.value)
  emit('change', selected.value)
}

onMounted(() => {
  selected.value = props.modelValue || null
})


</script>


